/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../$$_gendir/node_modules/angular2-spinner/dist/angular2-spinner.ngfactory';
import * as import2 from 'angular2-spinner/dist/angular2-spinner';
import * as import3 from '@ngx-translate/core/src/translate.pipe';
import * as import4 from '@ngx-translate/core/src/translate.service';
import * as import5 from '@angular/common';
import * as import6 from '@angular/forms';
import * as import7 from '../../../app/shared/directives/no-blank.directive';
import * as import8 from '../../../app/company-view/edit-company.component';
import * as import9 from '../../../app/services/company.service';
import * as import10 from '../../../app/services/local-storage.service';
import * as import11 from '../../../app/services/api.service';
import * as import12 from '@angular/router';
import * as import13 from 'angular2-notifications/src/notifications.service';
import * as import14 from '../../../app/services/form.service';
import * as import15 from '../../../app/services/response.service';
import * as import16 from '../../../app/services/phone.service';
const styles_EditCompanyComponent:any[] = ([] as any[]);
export const RenderType_EditCompanyComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_EditCompanyComponent,
  data: {}
}
);
function View_EditCompanyComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner center-v-h'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie danych firmy'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import2.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_EditCompanyComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                                    ',
      '\n                                                '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ERRORS.REQUIRED'));
    ck(v,1,0,currVal_0);
  });
}
function View_EditCompanyComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'info-hint error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_4)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.companyForm.controls['name'].touched && ((co.companyForm.controls['name'].errors == null)? (null as any): co.companyForm.controls['name'].errors.required));
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_EditCompanyComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'info-hint'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                    NIP w formacie XXXXXXXXXX\n                                                '])),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(null as any),(null as any));
}
function View_EditCompanyComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                                    ',
      '\n                                                '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ERRORS.REQUIRED'));
    ck(v,1,0,currVal_0);
  });
}
function View_EditCompanyComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                    Niepoprawny format numeru NIP\n                                                ']))
  ]
  ,(null as any),(null as any));
}
function View_EditCompanyComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'info-hint error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_7)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_8)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.companyForm.controls['nip'].touched && ((co.companyForm.controls['nip'].errors == null)? (null as any): co.companyForm.controls['nip'].errors.required));
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.companyForm.controls['nip'].touched && ((co.companyForm.controls['nip'].errors == null)? (null as any): co.companyForm.controls['nip'].errors.nip));
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_EditCompanyComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                                    ',
      '\n                                                '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ERRORS.REQUIRED'));
    ck(v,1,0,currVal_0);
  });
}
function View_EditCompanyComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'info-hint error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_10)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.companyForm.controls['country_id'].touched && ((co.companyForm.controls['country_id'].errors == null)? (null as any): co.companyForm.controls['country_id'].errors.required));
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_EditCompanyComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                                    ',
      '\n                                                '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ERRORS.REQUIRED'));
    ck(v,1,0,currVal_0);
  });
}
function View_EditCompanyComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'info-hint error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_12)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.companyForm.controls['city'].touched && ((co.companyForm.controls['city'].errors == null)? (null as any): co.companyForm.controls['city'].errors.required));
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_EditCompanyComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'info-hint'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                    Kod pocztowy w formacie XX-XXX\n                                                '])),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(null as any),(null as any));
}
function View_EditCompanyComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                                    ',
      '\n                                                '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ERRORS.REQUIRED'));
    ck(v,1,0,currVal_0);
  });
}
function View_EditCompanyComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                    Niepoprawny format kodu pocztowego\n                                                ']))
  ]
  ,(null as any),(null as any));
}
function View_EditCompanyComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'info-hint error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_15)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_16)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.companyForm.controls['postal_code'].touched && ((co.companyForm.controls['postal_code'].errors == null)? (null as any): co.companyForm.controls['postal_code'].errors.required));
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.companyForm.controls['postal_code'].touched && ((co.companyForm.controls['postal_code'].errors == null)? (null as any): co.companyForm.controls['postal_code'].errors.polishPostalCode));
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_EditCompanyComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                                    ',
      '\n                                                '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ERRORS.REQUIRED'));
    ck(v,1,0,currVal_0);
  });
}
function View_EditCompanyComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'info-hint error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_18)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.companyForm.controls['street'].touched && ((co.companyForm.controls['street'].errors == null)? (null as any): co.companyForm.controls['street'].errors.required));
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_EditCompanyComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                                    ',
      '\n                                                '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ERRORS.REQUIRED'));
    ck(v,1,0,currVal_0);
  });
}
function View_EditCompanyComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'info-hint error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_20)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.companyForm.controls['street_hn'].touched && ((co.companyForm.controls['street_hn'].errors == null)? (null as any): co.companyForm.controls['street_hn'].errors.required));
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_EditCompanyComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'row-large'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-narrow'
      ]
      ,
      [
        'type',
        'submit'
      ]
      ,
      [
        'value',
        'Zapisz'
      ]

    ]
      ,[[
        8,
        'disabled',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.loading || !co.companyForm.valid);
    ck(v,2,0,currVal_0);
  });
}
function View_EditCompanyComponent_23(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'info-hint'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                    Email w fromacie xxxxxx@xxxxxx.xx\n                                                '])),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(null as any),(null as any));
}
function View_EditCompanyComponent_25(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                                    ',
      '\n                                                '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ERRORS.REQUIRED'));
    ck(v,1,0,currVal_0);
  });
}
function View_EditCompanyComponent_26(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                    Niepoprawny format email\n                                                ']))
  ]
  ,(null as any),(null as any));
}
function View_EditCompanyComponent_24(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'info-hint error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_25)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_26)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.newClientForm.controls['email'].touched && ((co.newClientForm.controls['email'].errors == null)? (null as any): co.newClientForm.controls['email'].errors.required));
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.newClientForm.controls['email'].touched && ((co.newClientForm.controls['email'].errors == null)? (null as any): co.newClientForm.controls['email'].errors.nip));
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_EditCompanyComponent_27(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import6.NgSelectOption,[
      import0.ElementRef,
      import0.Renderer,
      [
        2,
        import6.SelectControlValueAccessor
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import0.ɵdid(147456,(null as any),0,import6.ɵq,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '',
      ' (',
      ')'
    ]
    ))
  ]
  ,(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'',v.context.$implicit['code'],'');
    ck(v,1,0,currVal_0);
    const currVal_1:any = import0.ɵinlineInterpolate(1,'',v.context.$implicit['code'],'');
    ck(v,2,0,currVal_1);
  },(ck,v) => {
    const currVal_2:any = v.context.$implicit['dial_code'];
    const currVal_3:any = v.context.$implicit['code'];
    ck(v,3,0,currVal_2,currVal_3);
  });
}
function View_EditCompanyComponent_28(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'info-hint'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                    Na ten numer będziemy wysyłać notyfikacje SMS.\n                                                '])),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(null as any),(null as any));
}
function View_EditCompanyComponent_30(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                    Niepoprawny format numeru telefonu.\n                                                ']))
  ]
  ,(null as any),(null as any));
}
function View_EditCompanyComponent_29(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'info-hint error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_30)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.newClientForm.controls['phone_notification'].touched && ((co.newClientForm.controls['phone_notification'].errors == null)? (null as any): co.newClientForm.controls['phone_notification'].errors.internationalPhoneNumber));
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_EditCompanyComponent_31(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import6.NgSelectOption,[
      import0.ElementRef,
      import0.Renderer,
      [
        2,
        import6.SelectControlValueAccessor
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import0.ɵdid(147456,(null as any),0,import6.ɵq,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '',
      ' (',
      ')'
    ]
    ))
  ]
  ,(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'',v.context.$implicit['code'],'');
    ck(v,1,0,currVal_0);
    const currVal_1:any = import0.ɵinlineInterpolate(1,'',v.context.$implicit['code'],'');
    ck(v,2,0,currVal_1);
  },(ck,v) => {
    const currVal_2:any = v.context.$implicit['dial_code'];
    const currVal_3:any = v.context.$implicit['code'];
    ck(v,3,0,currVal_2,currVal_3);
  });
}
function View_EditCompanyComponent_32(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'info-hint'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                    Na ten numer będziemy wysyłać weryfikacyjne hasła SMS przy logowaniu.\n                                                '])),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(null as any),(null as any));
}
function View_EditCompanyComponent_34(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                    Niepoprawny format numeru telefonu.\n                                                ']))
  ]
  ,(null as any),(null as any));
}
function View_EditCompanyComponent_33(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'info-hint error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_34)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.newClientForm.controls['phone_verification'].touched && ((co.newClientForm.controls['phone_verification'].errors == null)? (null as any): co.newClientForm.controls['phone_verification'].errors.internationalPhoneNumber));
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_EditCompanyComponent_22(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),147,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'section-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dodaj użytkownika do firmy:'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),141,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),138,'form',[
      [
        'action',
        '#'
      ]
      ,
      [
        'novalidate',
        ''
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngSubmit'
      ]
      ,
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,9).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,9).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngSubmit' === en)) {
        const pd_2:any = ((<any>co.addClient()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.ɵbf,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(540672,(null as any),0,import6.FormGroupDirective,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
      ,{form: [
        0,
        'form'
      ]
    },{ngSubmit: 'ngSubmit'}),
    import0.ɵprd(2048,(null as any),import6.ControlContainer,(null as any),[import6.FormGroupDirective]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatusGroup,[import6.ControlContainer],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),123,'div',[[
        'class',
        'row-large'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),21,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Email'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'formControlName',
        'email'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'focus'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,23)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,23).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,23)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,23)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,28).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      if (('blur' === en)) {
        const pd_5:any = ((<any>(co.EmailHint = false)) !== false);
        ad = (pd_5 && ad);
      }
      if (('focus' === en)) {
        const pd_6:any = ((<any>(co.EmailHint = true)) !== false);
        ad = (pd_6 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_23)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_24)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),32,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Telefon do notyfikacji'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),26,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'select',[
      [
        'class',
        'tiny'
      ]
      ,
      [
        'formControlName',
        'cc_phone_notification'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,46).onChange($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,46).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('change' === en)) {
        const pd_2:any = ((<any>co.validateField('phone_notification')) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.SelectControlValueAccessor,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.SelectControlValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_27)),
    import0.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'class',
        'small'
      ]
      ,
      [
        'formControlName',
        'phone_notification'
      ]
      ,
      [
        'type',
        'tel'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'focus'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,57)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,57).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,57)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,57)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,62).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      if (('blur' === en)) {
        const pd_5:any = ((<any>(co.phoneNotificationHint = false)) !== false);
        ad = (pd_5 && ad);
      }
      if (('focus' === en)) {
        const pd_6:any = ((<any>(co.phoneNotificationHint = true)) !== false);
        ad = (pd_6 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_28)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_29)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),32,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Telefon do weryfikacji'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),26,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'select',[
      [
        'class',
        'tiny'
      ]
      ,
      [
        'formControlName',
        'cc_phone_verification'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,80).onChange($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,80).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('change' === en)) {
        const pd_2:any = ((<any>co.validateField('phone_verification')) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.SelectControlValueAccessor,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.SelectControlValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_31)),
    import0.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'class',
        'small'
      ]
      ,
      [
        'formControlName',
        'phone_verification'
      ]
      ,
      [
        'type',
        'tel'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'focus'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,91)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,91).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,91)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,91)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,96).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      if (('blur' === en)) {
        const pd_5:any = ((<any>(co.phoneVerificationHint = false)) !== false);
        ad = (pd_5 && ad);
      }
      if (('focus' === en)) {
        const pd_6:any = ((<any>(co.phoneVerificationHint = true)) !== false);
        ad = (pd_6 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                             '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_32)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_33)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h4',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Uprawnienia użytkownika:'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'formControlName',
        'isOwner'
      ]
      ,
      [
        'type',
        'checkbox'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('change' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,114).onChange($event.target.checked)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,114).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('keyup' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,119).inputChanged($event)) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.CheckboxControlValueAccessor,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.CheckboxControlValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            Jest właścicielem\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'formControlName',
        'canEdit'
      ]
      ,
      [
        'type',
        'checkbox'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('change' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,128).onChange($event.target.checked)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,128).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('keyup' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,133).inputChanged($event)) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.CheckboxControlValueAccessor,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.CheckboxControlValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            Może edytować dane firmy\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵted((null as any),['\n\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'row-large'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-narrow'
      ]
      ,
      [
        'type',
        'submit'
      ]
      ,
      [
        'value',
        'Zapisz'
      ]

    ]
      ,[[
        8,
        'disabled',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_7:any = co.newClientForm;
    ck(v,9,0,currVal_7);
    const currVal_15:any = 'email';
    ck(v,25,0,currVal_15);
    const currVal_16:any = co.EmailHint;
    ck(v,31,0,currVal_16);
    const currVal_17:boolean = ((!co.EmailHint && co.newClientForm.controls['email'].touched) && co.newClientForm.controls['email'].errors);
    ck(v,34,0,currVal_17);
    const currVal_25:any = 'cc_phone_notification';
    ck(v,48,0,currVal_25);
    const currVal_26:any = co.phoneCodes;
    ck(v,53,0,currVal_26);
    const currVal_34:any = 'phone_notification';
    ck(v,59,0,currVal_34);
    const currVal_35:any = co.phoneNotificationHint;
    ck(v,65,0,currVal_35);
    const currVal_36:boolean = ((!co.phoneNotificationHint && co.newClientForm.controls['phone_notification'].touched) && co.newClientForm.controls['phone_notification'].errors);
    ck(v,68,0,currVal_36);
    const currVal_44:any = 'cc_phone_verification';
    ck(v,82,0,currVal_44);
    const currVal_45:any = co.phoneCodes;
    ck(v,87,0,currVal_45);
    const currVal_53:any = 'phone_verification';
    ck(v,93,0,currVal_53);
    const currVal_54:any = co.phoneVerificationHint;
    ck(v,99,0,currVal_54);
    const currVal_55:boolean = ((!co.phoneVerificationHint && co.newClientForm.controls['phone_verification'].touched) && co.newClientForm.controls['phone_verification'].errors);
    ck(v,102,0,currVal_55);
    const currVal_63:any = 'isOwner';
    ck(v,116,0,currVal_63);
    const currVal_71:any = 'canEdit';
    ck(v,130,0,currVal_71);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵnov(v,11).ngClassUntouched;
    const currVal_1:any = import0.ɵnov(v,11).ngClassTouched;
    const currVal_2:any = import0.ɵnov(v,11).ngClassPristine;
    const currVal_3:any = import0.ɵnov(v,11).ngClassDirty;
    const currVal_4:any = import0.ɵnov(v,11).ngClassValid;
    const currVal_5:any = import0.ɵnov(v,11).ngClassInvalid;
    const currVal_6:any = import0.ɵnov(v,11).ngClassPending;
    ck(v,7,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = import0.ɵnov(v,27).ngClassUntouched;
    const currVal_9:any = import0.ɵnov(v,27).ngClassTouched;
    const currVal_10:any = import0.ɵnov(v,27).ngClassPristine;
    const currVal_11:any = import0.ɵnov(v,27).ngClassDirty;
    const currVal_12:any = import0.ɵnov(v,27).ngClassValid;
    const currVal_13:any = import0.ɵnov(v,27).ngClassInvalid;
    const currVal_14:any = import0.ɵnov(v,27).ngClassPending;
    ck(v,22,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14);
    const currVal_18:any = import0.ɵnov(v,50).ngClassUntouched;
    const currVal_19:any = import0.ɵnov(v,50).ngClassTouched;
    const currVal_20:any = import0.ɵnov(v,50).ngClassPristine;
    const currVal_21:any = import0.ɵnov(v,50).ngClassDirty;
    const currVal_22:any = import0.ɵnov(v,50).ngClassValid;
    const currVal_23:any = import0.ɵnov(v,50).ngClassInvalid;
    const currVal_24:any = import0.ɵnov(v,50).ngClassPending;
    ck(v,45,0,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24);
    const currVal_27:any = import0.ɵnov(v,61).ngClassUntouched;
    const currVal_28:any = import0.ɵnov(v,61).ngClassTouched;
    const currVal_29:any = import0.ɵnov(v,61).ngClassPristine;
    const currVal_30:any = import0.ɵnov(v,61).ngClassDirty;
    const currVal_31:any = import0.ɵnov(v,61).ngClassValid;
    const currVal_32:any = import0.ɵnov(v,61).ngClassInvalid;
    const currVal_33:any = import0.ɵnov(v,61).ngClassPending;
    ck(v,56,0,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31,currVal_32,currVal_33);
    const currVal_37:any = import0.ɵnov(v,84).ngClassUntouched;
    const currVal_38:any = import0.ɵnov(v,84).ngClassTouched;
    const currVal_39:any = import0.ɵnov(v,84).ngClassPristine;
    const currVal_40:any = import0.ɵnov(v,84).ngClassDirty;
    const currVal_41:any = import0.ɵnov(v,84).ngClassValid;
    const currVal_42:any = import0.ɵnov(v,84).ngClassInvalid;
    const currVal_43:any = import0.ɵnov(v,84).ngClassPending;
    ck(v,79,0,currVal_37,currVal_38,currVal_39,currVal_40,currVal_41,currVal_42,currVal_43);
    const currVal_46:any = import0.ɵnov(v,95).ngClassUntouched;
    const currVal_47:any = import0.ɵnov(v,95).ngClassTouched;
    const currVal_48:any = import0.ɵnov(v,95).ngClassPristine;
    const currVal_49:any = import0.ɵnov(v,95).ngClassDirty;
    const currVal_50:any = import0.ɵnov(v,95).ngClassValid;
    const currVal_51:any = import0.ɵnov(v,95).ngClassInvalid;
    const currVal_52:any = import0.ɵnov(v,95).ngClassPending;
    ck(v,90,0,currVal_46,currVal_47,currVal_48,currVal_49,currVal_50,currVal_51,currVal_52);
    const currVal_56:any = import0.ɵnov(v,118).ngClassUntouched;
    const currVal_57:any = import0.ɵnov(v,118).ngClassTouched;
    const currVal_58:any = import0.ɵnov(v,118).ngClassPristine;
    const currVal_59:any = import0.ɵnov(v,118).ngClassDirty;
    const currVal_60:any = import0.ɵnov(v,118).ngClassValid;
    const currVal_61:any = import0.ɵnov(v,118).ngClassInvalid;
    const currVal_62:any = import0.ɵnov(v,118).ngClassPending;
    ck(v,113,0,currVal_56,currVal_57,currVal_58,currVal_59,currVal_60,currVal_61,currVal_62);
    const currVal_64:any = import0.ɵnov(v,132).ngClassUntouched;
    const currVal_65:any = import0.ɵnov(v,132).ngClassTouched;
    const currVal_66:any = import0.ɵnov(v,132).ngClassPristine;
    const currVal_67:any = import0.ɵnov(v,132).ngClassDirty;
    const currVal_68:any = import0.ɵnov(v,132).ngClassValid;
    const currVal_69:any = import0.ɵnov(v,132).ngClassInvalid;
    const currVal_70:any = import0.ɵnov(v,132).ngClassPending;
    ck(v,127,0,currVal_64,currVal_65,currVal_66,currVal_67,currVal_68,currVal_69,currVal_70);
    const currVal_72:any = (co.loading || !co.newClientForm.valid);
    ck(v,142,0,currVal_72);
  });
}
function View_EditCompanyComponent_36(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',([] as any[]),[[
        8,
        'className',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleMarketing(v.context.$implicit.uuid)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',([] as any[]),[[
        8,
        'className',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleTechnical(v.context.$implicit.uuid)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',([] as any[]),[[
        8,
        'className',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.togglePayments(v.context.$implicit.uuid)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.email;
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵinlineInterpolate(1,'btn btn-small btn-',(v.context.$implicit.pivot.marketing? 'success': 'danger'),'');
    ck(v,6,0,currVal_1);
    const currVal_2:any = (v.context.$implicit.pivot.marketing? 'DOZWOLONE': 'NIEDOZWOLONE');
    ck(v,7,0,currVal_2);
    const currVal_3:any = import0.ɵinlineInterpolate(1,'btn btn-small btn-',(v.context.$implicit.pivot.technical? 'success': 'danger'),'');
    ck(v,10,0,currVal_3);
    const currVal_4:any = (v.context.$implicit.pivot.technical? 'DOZWOLONE': 'NIEDOZWOLONE');
    ck(v,11,0,currVal_4);
    const currVal_5:any = import0.ɵinlineInterpolate(1,'btn btn-small btn-',(v.context.$implicit.pivot.payments? 'success': 'danger'),'');
    ck(v,14,0,currVal_5);
    const currVal_6:any = (v.context.$implicit.pivot.payments? 'DOZWOLONE': 'NIEDOZWOLONE');
    ck(v,15,0,currVal_6);
  });
}
function View_EditCompanyComponent_35(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),37,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'section-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Użytkownicy firmy:'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),31,'table',[[
        'class',
        'table'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),22,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),19,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Użytkownik'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Notyfikacje'])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['marketingowe'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Notyfikacje'])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['techniczne'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Notyfikacje'])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['księgowość + płatności'])),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_36)),
    import0.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.users;
    ck(v,34,0,currVal_0);
  },(null as any));
}
function View_EditCompanyComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),214,'div',[[
        'class',
        'table-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),211,'table',[[
        'class',
        'standard noHover'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),208,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),205,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),193,'td',[[
        'style',
        'width:50%'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),190,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'section-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dane firmy'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),184,'div',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),181,'form',[
      [
        'action',
        '#'
      ]
      ,
      [
        'novalidate',
        ''
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngSubmit'
      ]
      ,
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,19).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,19).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngSubmit' === en)) {
        const pd_2:any = ((<any>co.editCompany()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.ɵbf,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(540672,(null as any),0,import6.FormGroupDirective,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
      ,{form: [
        0,
        'form'
      ]
    },{ngSubmit: 'ngSubmit'}),
    import0.ɵprd(2048,(null as any),import6.ControlContainer,(null as any),[import6.FormGroupDirective]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatusGroup,[import6.ControlContainer],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),174,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Nazwa firmy'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'formControlName',
        'name'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'focus'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,33)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,33).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,33)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,33)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,38).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      if (('blur' === en)) {
        const pd_5:any = ((<any>(co.companyNameHint = false)) !== false);
        ad = (pd_5 && ad);
      }
      if (('focus' === en)) {
        const pd_6:any = ((<any>(co.companyNameHint = true)) !== false);
        ad = (pd_6 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_3)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),21,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['NIP'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'formControlName',
        'nip'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'focus'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,53)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,53).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,53)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,53)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,58).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      if (('blur' === en)) {
        const pd_5:any = ((<any>(co.NIPHint = false)) !== false);
        ad = (pd_5 && ad);
      }
      if (('focus' === en)) {
        const pd_6:any = ((<any>(co.NIPHint = true)) !== false);
        ad = (pd_6 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_5)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_6)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),28,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Kraj'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'select',[[
        'formControlName',
        'country_id'
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('change' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,76).onChange($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,76).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.SelectControlValueAccessor,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.SelectControlValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'option',[
      [
        'disabled',
        ''
      ]
      ,
      [
        'value',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import6.NgSelectOption,[
      import0.ElementRef,
      import0.Renderer,
      [
        2,
        import6.SelectControlValueAccessor
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import0.ɵdid(147456,(null as any),0,import6.ɵq,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Wybierz kraj'])),
    (l()(),import0.ɵted((null as any),['\n                                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'option',[
      [
        'selected',
        ''
      ]
      ,
      [
        'value',
        '518'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import6.NgSelectOption,[
      import0.ElementRef,
      import0.Renderer,
      [
        2,
        import6.SelectControlValueAccessor
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import0.ɵdid(147456,(null as any),0,import6.ɵq,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Polska'])),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_9)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Miejscowość'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'formControlName',
        'city'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,106)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,106).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,106)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,106)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,111).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_11)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),21,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Kod pocztowy'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'formControlName',
        'postal_code'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'focus'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,126)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,126).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,126)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,126)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,131).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      if (('blur' === en)) {
        const pd_5:any = ((<any>(co.postalCodeHint = false)) !== false);
        ad = (pd_5 && ad);
      }
      if (('focus' === en)) {
        const pd_6:any = ((<any>(co.postalCodeHint = true)) !== false);
        ad = (pd_6 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_13)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_14)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Ulica'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'formControlName',
        'street'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,149)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,149).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,149)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,149)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,154).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_17)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Numer domu'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'formControlName',
        'street_hn'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,169)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,169).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,169)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,169)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,174).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_19)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Numer mieszkania'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'formControlName',
        'street_ln'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,187)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,187).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,187)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,187)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,192).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_21)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'td',[[
        'style',
        'vertical-align: top;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_22)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_35)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_7:any = co.companyForm;
    ck(v,19,0,currVal_7);
    const currVal_15:any = 'name';
    ck(v,35,0,currVal_15);
    const currVal_16:any = (co.companyForm.controls['name'].touched && co.companyForm.controls['name'].errors);
    ck(v,41,0,currVal_16);
    const currVal_24:any = 'nip';
    ck(v,55,0,currVal_24);
    const currVal_25:any = co.NIPHint;
    ck(v,61,0,currVal_25);
    const currVal_26:boolean = ((!co.NIPHint && co.companyForm.controls['nip'].touched) && co.companyForm.controls['nip'].errors);
    ck(v,64,0,currVal_26);
    const currVal_34:any = 'country_id';
    ck(v,78,0,currVal_34);
    const currVal_35:any = '';
    ck(v,83,0,currVal_35);
    const currVal_36:any = '';
    ck(v,84,0,currVal_36);
    const currVal_37:any = '518';
    ck(v,88,0,currVal_37);
    const currVal_38:any = '518';
    ck(v,89,0,currVal_38);
    const currVal_39:any = (co.companyForm.controls['country_id'].touched && co.companyForm.controls['country_id'].errors);
    ck(v,94,0,currVal_39);
    const currVal_47:any = 'city';
    ck(v,108,0,currVal_47);
    const currVal_48:any = (co.companyForm.controls['city'].touched && co.companyForm.controls['city'].errors);
    ck(v,114,0,currVal_48);
    const currVal_56:any = 'postal_code';
    ck(v,128,0,currVal_56);
    const currVal_57:any = co.postalCodeHint;
    ck(v,134,0,currVal_57);
    const currVal_58:boolean = ((!co.postalCodeHint && co.companyForm.controls['postal_code'].touched) && co.companyForm.controls['postal_code'].errors);
    ck(v,137,0,currVal_58);
    const currVal_66:any = 'street';
    ck(v,151,0,currVal_66);
    const currVal_67:any = (co.companyForm.controls['street'].touched && co.companyForm.controls['street'].errors);
    ck(v,157,0,currVal_67);
    const currVal_75:any = 'street_hn';
    ck(v,171,0,currVal_75);
    const currVal_76:any = (co.companyForm.controls['street_hn'].touched && co.companyForm.controls['street_hn'].errors);
    ck(v,177,0,currVal_76);
    const currVal_84:any = 'street_ln';
    ck(v,189,0,currVal_84);
    const currVal_85:any = co.canEdit;
    ck(v,196,0,currVal_85);
    const currVal_86:any = co.isOwner;
    ck(v,206,0,currVal_86);
    const currVal_87:any = co.isOwner;
    ck(v,209,0,currVal_87);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,21).ngClassUntouched;
    const currVal_1:any = import0.ɵnov(v,21).ngClassTouched;
    const currVal_2:any = import0.ɵnov(v,21).ngClassPristine;
    const currVal_3:any = import0.ɵnov(v,21).ngClassDirty;
    const currVal_4:any = import0.ɵnov(v,21).ngClassValid;
    const currVal_5:any = import0.ɵnov(v,21).ngClassInvalid;
    const currVal_6:any = import0.ɵnov(v,21).ngClassPending;
    ck(v,17,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = import0.ɵnov(v,37).ngClassUntouched;
    const currVal_9:any = import0.ɵnov(v,37).ngClassTouched;
    const currVal_10:any = import0.ɵnov(v,37).ngClassPristine;
    const currVal_11:any = import0.ɵnov(v,37).ngClassDirty;
    const currVal_12:any = import0.ɵnov(v,37).ngClassValid;
    const currVal_13:any = import0.ɵnov(v,37).ngClassInvalid;
    const currVal_14:any = import0.ɵnov(v,37).ngClassPending;
    ck(v,32,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14);
    const currVal_17:any = import0.ɵnov(v,57).ngClassUntouched;
    const currVal_18:any = import0.ɵnov(v,57).ngClassTouched;
    const currVal_19:any = import0.ɵnov(v,57).ngClassPristine;
    const currVal_20:any = import0.ɵnov(v,57).ngClassDirty;
    const currVal_21:any = import0.ɵnov(v,57).ngClassValid;
    const currVal_22:any = import0.ɵnov(v,57).ngClassInvalid;
    const currVal_23:any = import0.ɵnov(v,57).ngClassPending;
    ck(v,52,0,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23);
    const currVal_27:any = import0.ɵnov(v,80).ngClassUntouched;
    const currVal_28:any = import0.ɵnov(v,80).ngClassTouched;
    const currVal_29:any = import0.ɵnov(v,80).ngClassPristine;
    const currVal_30:any = import0.ɵnov(v,80).ngClassDirty;
    const currVal_31:any = import0.ɵnov(v,80).ngClassValid;
    const currVal_32:any = import0.ɵnov(v,80).ngClassInvalid;
    const currVal_33:any = import0.ɵnov(v,80).ngClassPending;
    ck(v,75,0,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31,currVal_32,currVal_33);
    const currVal_40:any = import0.ɵnov(v,110).ngClassUntouched;
    const currVal_41:any = import0.ɵnov(v,110).ngClassTouched;
    const currVal_42:any = import0.ɵnov(v,110).ngClassPristine;
    const currVal_43:any = import0.ɵnov(v,110).ngClassDirty;
    const currVal_44:any = import0.ɵnov(v,110).ngClassValid;
    const currVal_45:any = import0.ɵnov(v,110).ngClassInvalid;
    const currVal_46:any = import0.ɵnov(v,110).ngClassPending;
    ck(v,105,0,currVal_40,currVal_41,currVal_42,currVal_43,currVal_44,currVal_45,currVal_46);
    const currVal_49:any = import0.ɵnov(v,130).ngClassUntouched;
    const currVal_50:any = import0.ɵnov(v,130).ngClassTouched;
    const currVal_51:any = import0.ɵnov(v,130).ngClassPristine;
    const currVal_52:any = import0.ɵnov(v,130).ngClassDirty;
    const currVal_53:any = import0.ɵnov(v,130).ngClassValid;
    const currVal_54:any = import0.ɵnov(v,130).ngClassInvalid;
    const currVal_55:any = import0.ɵnov(v,130).ngClassPending;
    ck(v,125,0,currVal_49,currVal_50,currVal_51,currVal_52,currVal_53,currVal_54,currVal_55);
    const currVal_59:any = import0.ɵnov(v,153).ngClassUntouched;
    const currVal_60:any = import0.ɵnov(v,153).ngClassTouched;
    const currVal_61:any = import0.ɵnov(v,153).ngClassPristine;
    const currVal_62:any = import0.ɵnov(v,153).ngClassDirty;
    const currVal_63:any = import0.ɵnov(v,153).ngClassValid;
    const currVal_64:any = import0.ɵnov(v,153).ngClassInvalid;
    const currVal_65:any = import0.ɵnov(v,153).ngClassPending;
    ck(v,148,0,currVal_59,currVal_60,currVal_61,currVal_62,currVal_63,currVal_64,currVal_65);
    const currVal_68:any = import0.ɵnov(v,173).ngClassUntouched;
    const currVal_69:any = import0.ɵnov(v,173).ngClassTouched;
    const currVal_70:any = import0.ɵnov(v,173).ngClassPristine;
    const currVal_71:any = import0.ɵnov(v,173).ngClassDirty;
    const currVal_72:any = import0.ɵnov(v,173).ngClassValid;
    const currVal_73:any = import0.ɵnov(v,173).ngClassInvalid;
    const currVal_74:any = import0.ɵnov(v,173).ngClassPending;
    ck(v,168,0,currVal_68,currVal_69,currVal_70,currVal_71,currVal_72,currVal_73,currVal_74);
    const currVal_77:any = import0.ɵnov(v,191).ngClassUntouched;
    const currVal_78:any = import0.ɵnov(v,191).ngClassTouched;
    const currVal_79:any = import0.ɵnov(v,191).ngClassPristine;
    const currVal_80:any = import0.ɵnov(v,191).ngClassDirty;
    const currVal_81:any = import0.ɵnov(v,191).ngClassValid;
    const currVal_82:any = import0.ɵnov(v,191).ngClassInvalid;
    const currVal_83:any = import0.ɵnov(v,191).ngClassPending;
    ck(v,186,0,currVal_77,currVal_78,currVal_79,currVal_80,currVal_81,currVal_82,currVal_83);
  });
}
export function View_EditCompanyComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_1)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_EditCompanyComponent_2)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import8.EditCompanyComponent = v.component;
    const currVal_0:any = co.companyLoading;
    ck(v,1,0,currVal_0);
    const currVal_1:boolean = !co.companyLoading;
    ck(v,4,0,currVal_1);
  },(null as any));
}
function View_EditCompanyComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-edit-company',([] as any[]),(null as any),(null as any),(null as any),View_EditCompanyComponent_0,RenderType_EditCompanyComponent)),
    import0.ɵdid(114688,(null as any),0,import8.EditCompanyComponent,[
      import9.CompanyService,
      import10.LocalStorageService,
      import11.ApiService,
      import12.Router,
      import13.NotificationsService,
      import14.FormService,
      import15.ResponseService,
      import16.PhoneService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const EditCompanyComponentNgFactory:import0.ComponentFactory<import8.EditCompanyComponent> = import0.ɵccf('app-edit-company',import8.EditCompanyComponent,View_EditCompanyComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/company-view/edit-company.component.ngfactory.ts